import { useState } from 'react';
import {
  Card,
  CardContent,
  Typography,
  Pagination,
  Box,
} from '@mui/material';
import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';

export default function WorkoutsBlock({ workouts }) {
  const [currentPage, setCurrentPage] = useState(1);
  const ITEMS_PER_PAGE = 10;

  const handlePageChange = (event, page) => {
    setCurrentPage(page);
  };

  const startIndex = (currentPage - 1) * ITEMS_PER_PAGE;
  const endIndex = startIndex + ITEMS_PER_PAGE;
  const displayedWorkouts = workouts.slice(startIndex, endIndex);

  return (
    <Box>
      {displayedWorkouts.map((workout) => (
        <Card key={workout.id} sx={{ mb: 2 }}>
          <CardContent>
            <Typography variant="h6">{workout.name}</Typography>
            <Typography variant="body2" color="textSecondary">
              {workout.description}
            </Typography>
            <Typography variant="caption" color="textSecondary">
              <FormattedMessage id="workouts.label.createdAt" defaultMessage="Created At" />:{' '}
              {new Date(workout.createdAt).toLocaleString()}
            </Typography>
          </CardContent>
        </Card>
      ))}
      <Pagination
        count={Math.ceil(workouts.length / ITEMS_PER_PAGE)}
        page={currentPage}
        onChange={handlePageChange}
        sx={{ mt: 3, display: 'flex', justifyContent: 'center' }}
      />
    </Box>
  );
}

WorkoutsBlock.propTypes = {
  workouts: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
      name: PropTypes.string.isRequired,
      description: PropTypes.string,
      createdAt: PropTypes.string.isRequired,
    })
  ).isRequired,
};
